<svg-icon
  *ngIf="isBusy"
  [svgClass]="addClass + ' animate-spin'"
  src="../../assets/images/spinner.svg"
></svg-icon>
